import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { FamilyProvider } from '../context/FamilyContext';
import FamilyDashboard from '../components/FamilyDashboard';
import FamilyDashboardView from '../components/viewsFamily/DashboardView/DashboardViewFamily';
import ManageFamily from '../components/viewsFamily/ManageFamilyView/ManageFamilyView';
import FamilySettingsView from '../components/viewsFamily/FamilySettingsView/FamilySettingsView';
import ChildView from '../components/viewsFamily/ChildrenView/ChildView';

const FamilyRoutes = () => {
  
  return (
    <FamilyProvider>
      <Routes>
        <Route element={<FamilyDashboard />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<FamilyDashboardView />} />
          <Route path="manage" element={<ManageFamily />} />
          <Route path="settings" element={<FamilySettingsView />} />
          <Route path=":childName/*" element={<ChildView />} />
        </Route>
      </Routes>
    </FamilyProvider>
  );
};

export default FamilyRoutes;